import classNames from 'classnames';
import { BatteryFullIcon, BatteryLowIcon, BatteryMediumIcon, LucideBattery } from 'lucide-react';

interface IBatteryIconProps {
  percentage: number;
  className?: string;
}

function BatteryIcon({ percentage, className }: IBatteryIconProps) {
  let color = 'text-green-500';
  let IconComponent = BatteryFullIcon;
  if (percentage <= 60) {
    IconComponent = BatteryMediumIcon;
  }
  if (percentage <= 40) {
    color = 'text-yellow-500';
  }
  if (percentage <= 30) {
    IconComponent = BatteryLowIcon;
  }
  if (percentage <= 20) {
    color = 'text-red-500';
  }
  if (percentage <= 5) {
    color = 'text-red-800';
    IconComponent = LucideBattery;
  }
  return <IconComponent className={classNames(color, className)} />;
}

export default BatteryIcon;
